export default "<div class=\"page\">\n\n  <h2>User Dashboard</h2>\n\n  <specapp-user-component></specapp-user-component>\n</div>\n";